import { render, staticRenderFns } from "./testSysUser.vue?vue&type=template&id=6c33dedc&scoped=true"
import script from "./testSysUser.vue?vue&type=script&lang=js"
export * from "./testSysUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c33dedc",
  null
  
)

export default component.exports